import { ERROR_CODES } from "@/libs/error/types";
import { useMutation } from "@tanstack/react-query";
import { UserUpdate } from "libs/schema/user";
import axiosWithCredentials from "../commons";
import { CURRENT_USER_API } from "./user/common";
import { useSession } from "next-auth/react";
import { getHttpRequestDurationHistogram } from "@/src/telemetry/metrics";
import {
  areMetricsEnabledClientSide,
  areOtelMetricsEnabled,
} from "@/src/telemetry/utils";

export const useUpdateCurrentUser = (
  onError?: (response: any) => void,
  onSuccess?: () => void,
) => {
  const { update } = useSession();
  return useMutation(
    async (updatedUser: UserUpdate) => {
      const start = performance.now();
      const response = await axiosWithCredentials.put(CURRENT_USER_API, {
        ...updatedUser,
      });
      const duration = performance.now() - start;
      if (areMetricsEnabledClientSide() || areOtelMetricsEnabled) {
        getHttpRequestDurationHistogram().record(duration, {
          method: "PUT",
          route: CURRENT_USER_API,
          status_code: response.status,
        });
      }
    },
    {
      onSuccess: async () => {
        onSuccess && onSuccess();
        return await update();
      },
      onError({ response }) {
        return onError && onError(response);
      },
      useErrorBoundary: ({ response }) =>
        response !== undefined &&
        response?.status >= ERROR_CODES.INTERNAL_ERROR,
    },
  );
};
